import React from 'react';

interface Props {
  img: string | undefined;
}

const SignatureValues: React.FC<Props> = ({ img }: Props) => {
  return (
    <div className="d-flex" style={{ maxWidth: '100%' }} data-testid="signature-field-test">
      {img && <img style={{ maxWidth: '100%' }} src={img} alt="Signature" />}
      {!img && <span>-</span>}
    </div>
  );
};
export default SignatureValues;
